import { Grid, TextField, DialogActions, Button } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { TPagamentoCartao } from ".";

interface ManualFormProps {
    onClose: () => void;
    onSubmit: (data: TPagamentoCartao) => void;
    isEdit: boolean;
}

export default function ManualForm({ onClose, onSubmit, isEdit }: ManualFormProps) {

    const { control, handleSubmit } = useFormContext<TPagamentoCartao>();

    return (
        <Grid container spacing={2} mt={0.5}>
            <Grid size={{ xs: 12 }}>
                <Controller
                    name="valor"
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field }) => (
                        <TextField
                            required
                            disabled
                            label="Valor"
                            fullWidth
                            value={field.value}
                        />
                    )}
                />
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Controller
                    name="nsu"
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            required
                            label="Nsu"
                            fullWidth
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            error={Boolean(error)}
                            helperText={error ? "Campo obrigatório" : ""}
                        />
                    )}
                />
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Controller
                    name="autorizacao"
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            required
                            label="Autorização"
                            fullWidth
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            error={Boolean(error)}
                            helperText={error ? "Campo obrigatório" : ""}
                        />
                    )}
                />

            </Grid>

            {/* DialogActions */}
            <Grid size={{ xs: 12 }}>
                <DialogActions sx={{ px: 0, pt: 2 }}>
                    <Button onClick={onClose} color="primary">
                        Cancelar
                    </Button>
                    <Button 
                        onClick={handleSubmit(onSubmit)} 
                        color="primary" 
                        variant="contained"
                    >
                        {isEdit ? "Editar" : "Receber"}
                    </Button>
                </DialogActions>
            </Grid>
        </Grid>
    )
}